import { SyntheticEvent } from 'react';

interface InfoIconProps {
  fill: string;
  width?: string;
  height?: string;
  cursor?: string;
  onClick?: (e: SyntheticEvent) => void;
}

export const MinusIcon = ({ fill, width, height }: InfoIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16 10H10H4"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
